var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTotalCareBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20630_5598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20630_5598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.24867 8.31416L5.27269 7.35278C5.19193 7.27201 5.10499 7.23069 5.01188 7.22883C4.91877 7.22695 4.82997 7.26827 4.74546 7.35278C4.66095 7.43729 4.6187 7.52759 4.6187 7.62368C4.6187 7.71978 4.66095 7.81008 4.74546 7.89458L5.92334 9.07246C6.01907 9.16819 6.12751 9.21605 6.24867 9.21605C6.36981 9.21605 6.47825 9.16819 6.57398 9.07246L9.25057 6.39587C9.33135 6.31511 9.37266 6.22574 9.37453 6.12777C9.37641 6.0298 9.33509 5.93856 9.25057 5.85405C9.16607 5.76955 9.0782 5.7273 8.98696 5.7273C8.89573 5.7273 8.80786 5.76955 8.72336 5.85405L6.24867 8.31416ZM7.00461 12.808C6.27704 12.808 5.59063 12.6699 4.94538 12.3936C4.30013 12.1173 3.73536 11.7371 3.25106 11.253C2.76676 10.7689 2.38639 10.2044 2.10996 9.55947C1.83353 8.91453 1.69531 8.22827 1.69531 7.5007C1.69531 6.76341 1.83347 6.07457 2.10977 5.43419C2.38608 4.79379 2.76626 4.23145 3.25033 3.74716C3.73441 3.26285 4.29893 2.88249 4.94388 2.60605C5.58882 2.32962 6.27508 2.19141 7.00265 2.19141C7.73995 2.19141 8.42879 2.32956 9.06917 2.60586C9.70956 2.88217 10.2719 3.26236 10.7562 3.74643C11.2405 4.23051 11.6209 4.79259 11.8973 5.43268C12.1737 6.07277 12.312 6.76145 12.312 7.49875C12.312 8.22632 12.1738 8.91273 11.8975 9.55797C11.6212 10.2032 11.241 10.768 10.7569 11.2523C10.2729 11.7366 9.71076 12.117 9.07067 12.3934C8.43059 12.6698 7.7419 12.808 7.00461 12.808Z",
    fill: "#6BA9FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTotalCareBadge);
export default __webpack_public_path__ + "static/media/ic-total-care-badge.967cfa86a497000475de6d35b8a1a599.svg";
export { ForwardRef as ReactComponent };